import { FunctionComponent, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import { PanelGroup, Panel } from '@cbridge-tools/resizable-panels';
import { ResizeHandle } from '@cbridge-tools/resize-handle';
import { usePersistedPanelLayout } from '../_hooks/usePersistedPanelLayout';
import { panelLayoutSettingKey } from '../_helpers/panelLayoutSetting';
import { NavigationPanel } from './nav/NavigationPanel';

interface IConfigPageLayoutProps {
  /** Hard pixel floor for the navigation panel width. */
  navMinWidth?: number;
  /** Percentage floor for the navigation panel width. */
  navMinSize?: number;
  /** Page prefix of the profile setting that persists the nav/page split (`{settingsKey}.layout.nav`). */
  settingsKey?: string;
}

export const ConfigPageLayout: FunctionComponent<PropsWithChildren<IConfigPageLayoutProps>> = (props) => {
  const { children, navMinWidth, navMinSize, settingsKey } = props;
  const layoutProps = usePersistedPanelLayout(settingsKey && panelLayoutSettingKey(settingsKey, 'nav'));

  return (
    <PanelGroup direction={'horizontal'} id={'config-layout'} {...layoutProps}>
      <NavigationPanel minWidth={navMinWidth} minSize={navMinSize}>
        {children}
      </NavigationPanel>
      <ResizeHandle withDivider={true} />
      <Panel id={'page'}>
        <Outlet />
      </Panel>
    </PanelGroup>
  );
};
